import api from "../api/index"
import config from '@/config'

import langMap from '@/utils/language'
import store from '@/store'
// 存储WebSocket实例的映射
const socketInstanceMap = {};
const isDev = process.env.NODE_ENV === 'development';

// 开发环境 WebSocket 基础 URL 字典：/ssf, /sst, /ssdd, /sound, /monitor
// 都指向 config.baseUrl.dev 对应 IP 的 18014 端口
const getDevBaseUrlMap = () => {
  const devUrl = new URL(config.baseUrl.dev);
  const devHostWithPort = `${devUrl.protocol}//${devUrl.hostname}:18014`;

  return {
    '/ssf': devHostWithPort,
    '/sst': devHostWithPort,
    '/ssdd': devHostWithPort,
    '/sound': devHostWithPort,
    '/monitor': devHostWithPort
  };
};

//mvp端口
export const getMvpUrlMap = (() => {
  const devUrl = new URL(config.baseUrl.dev);
  if(isDev){
    return config.baseUrl.dev.replace('/api','');
  }
  return window.location.origin;
})();

/**
 * WebSocket 基础 URL (协议 + 主机名)
 * 开发环境：使用配置文件中的 baseUrl
 * 生产环境：使用当前页面域名
 */
export const getSocketUrl = ((pathname = '/') => {
  let baseUrlC;
  
  if (isDev) {
    //dev 地址
    baseUrlC = config.baseUrl.dev.replace('/api','');
  } else {
    // 生产环境：使用当前页面域名
    baseUrlC = window.location.origin;
  }
  return baseUrlC;
})

// 发送消息
export const sendMsg = (key, message) => {
  if (socketInstanceMap[key] && socketInstanceMap[key].socketFlag) {
    if(Object.prototype.toString.call(message) === '[object Object]'){
      message.language = store.state.app.language;
      message = JSON.stringify(message)
    }
    socketInstanceMap[key].send(message)
  }
}

/**
 * 直接使用 URL 初始化 WebSocket 连接
 * @param {string} url - WebSocket URL 路径（默认会拼接 buildWebSocketUrl）
 * @param {string} key - WebSocket 实例的唯一标识
 * @param {string} id - 可选的初始消息
 * @param {Function} callback - 接收消息的回调函数
 * @param {Function} getSocketInstance - 获取 socket 实例的回调
 * @param {Function} errorConnect - 错误连接的回调
 * @param {boolean} useFullUrl - 开启则不拼接 buildWebSocketUrl，直接使用传入 URL
 */
export const connectWithUrl = (url, key, id, callback, getSocketInstance, errorConnect, useFullUrl = false) => {
  const lang = store.state.app.language;
  let webSocket = null,finalUrl = null;
  if (!url) {
    console.error(`[WebSocket-${key}] ${langMap.tip[lang]}: URL is required`);
    return;
  }
  
  // 计算最终连接地址：默认拼接基础 URL，useFullUrl 为 true 时不拼接
  if(useFullUrl){
    finalUrl = url
  }else{
    finalUrl = getSocketUrl(url) + url
  }
   const baseUrl = new URL(finalUrl)
   const protocol = baseUrl.protocol === 'https:' ? 'wss:' : 'ws:';
   const hostname = baseUrl.host;
   const pathname = baseUrl.pathname
   finalUrl = `${protocol}//${hostname + pathname}`
   
  if ("WebSocket" in window) {
    try {
      webSocket = new WebSocket(finalUrl);
      
      // 将WebSocket实例添加到全局数组
      if (!window._globalWebsockets) {
        window._globalWebsockets = [];
      }
      window._globalWebsockets.push(webSocket);
      
      // 存储实例到映射
      socketInstanceMap[key] = webSocket;
      
      webSocket.onopen = function () {
        console.log(`[WebSocket-${key}] ${langMap.tip[lang]}: ${langMap.connectSuccess[lang]}`);
        if (id) {
          webSocket.send(id);
        }
        webSocket.socketFlag = true;
        getSocketInstance && getSocketInstance(webSocket);
      };
      
      webSocket.onmessage = function (evt) {
        var receivedMsg = evt.data;
        callback(receivedMsg);
      };
      
      webSocket.onclose = function () {
        console.log(`[WebSocket-${key}] ${langMap.tip[lang]}: ${langMap.connectClose[lang]}`);
        webSocket.socketFlag = false;
      };
      
      webSocket.onerror = function () {
        console.error(`[WebSocket-${key}] ${langMap.tip[lang]}: ${langMap.connectError[lang]}`);
        webSocket.socketFlag = false;
        errorConnect && errorConnect('error');
      };
    } catch (error) {
      console.error(`[WebSocket-${key}] ${langMap.tip[lang]}: Failed to create WebSocket`, error);
      errorConnect && errorConnect('error');
    }
  } else {
    console.error(`[WebSocket-${key}] ${langMap.tip[lang]}: WebSocket is not supported`);
    errorConnect && errorConnect('error');
  }
};

// 初始化 websocket
export const contact = (keyData, id, callback, _this,getSocketInstance,errorConnect) => {
  let webSocket = null;
  const lang = store.state.app.language; // 获取当前语言
  let key = '',extraData = '';
  if(Object.prototype.toString.call(keyData) === '[object Object]'){
    key = keyData['key']
    extraData = keyData['extraData']
  }else{
    key = keyData
  }
  api.getData('system-server/config/list?keys='+key, _this).then((r)=>{
    if(r.state==0){
      console.error(`[WebSocket-${key}] ${langMap.tip[lang]}: ${r.msg}`);
    }else{
      let config = r.data[key];
      if(!config){
        console.error(`[WebSocket-${key}] ${langMap.tip[lang]}: ${langMap.configNotFound[lang]}`);
        return;
      }
      let url = config.configValue
      if(!url){
        console.error(`[WebSocket-${key}] ${langMap.tip[lang]}: ${langMap.noConfigConnectUrl[lang]}`);
        return;
      }
      if ("WebSocket" in window) {
        webSocket = new WebSocket(url+extraData);
        // 将WebSocket实例添加到全局数组
        if (!window._globalWebsockets) {
          window._globalWebsockets = [];
        }
        window._globalWebsockets.push(webSocket);
        // 存储实例到映射
        socketInstanceMap[key] = webSocket;
        webSocket.onopen = function () {
          console.log(`[WebSocket-${key}] ${langMap.tip[lang]}: ${langMap.connectSuccess[lang]}`);
          if(id){
            webSocket.send(id);
          }
          webSocket.socketFlag = true
          getSocketInstance && getSocketInstance(webSocket)
        };
        webSocket.onmessage = function (evt) {
          var receivedMsg = evt.data;
          //console.log("接受消息：" + receivedMsg);
          callback(receivedMsg);
        };
        webSocket.onclose = function () {
          console.log(`[WebSocket-${key}] ${langMap.tip[lang]}: ${langMap.connectClose[lang]}`);
          webSocket.socketFlag = false;
        };
        webSocket.onerror = function () {
          console.error(`[WebSocket-${key}] ${langMap.tip[lang]}: ${langMap.connectError[lang]}`);
          webSocket.socketFlag = false;
          errorConnect && errorConnect('error')
        };
      }
    }
  })
}
